import { API_BASE } from '../config/apiBase';


/**
 * Resolve image URLs from the API (uploads, avatars, etc.)
 * In production, frontend and API are on different subdomains.
 * Backend stores paths like "/api/uploads/avatar_xxx.png" which need
 * the API base URL prepended to load correctly.
 */
export function resolveImageUrl(src) {
    if (!src) return '';
    // Already absolute URL — return as-is
    if (src.startsWith('http://') || src.startsWith('https://')) return src;
    // Relative API path — prepend backend URL
    if (src.startsWith('/api/')) return `${API_BASE}${src}`;
    return src;
}
